import React from "react";
import {CategoryComponentInterface} from "../interfaces/CategoryState";
import CategoryRepository from "../repository/CategoryRepository";
import {get} from "lodash";
import MarketContext from "../../Main/interface/MarketContext";

export default class CategoryController {
    protected state: CategoryComponentInterface;
    protected repository: CategoryRepository;
    protected setState: React.Dispatch<React.SetStateAction<CategoryComponentInterface>>;

    constructor(state: CategoryComponentInterface, setState: React.Dispatch<React.SetStateAction<CategoryComponentInterface>>) {
        this.state = state;
        this.setState = setState;
        this.repository = new CategoryRepository();
    }

    async getCategories(shopId?: string) {
        if (!shopId)
            return null;
        const regexObjectId = /^[a-f\d]{24}$/i

        if (!regexObjectId.test(shopId)) {
            return this.updateState({loading: false, error: true});
        }

        this.updateState({loading: true});
        const data = await this.repository.all(shopId)

        if (get(data, "status", false)) {
            return this.updateState({loading: false, categories: get(data.data, "data", [])});
        }

        return this.updateState({loading: false, error: true});
    }

    setSelectedCategory(categoryId: string, context: MarketContext) {
        context.setState(prevState => ({...prevState, categoryActive: categoryId}));
        this.updateState({activeCategory: categoryId});
    }

    private updateState(state: object) {
        const newState = {...this.state, ...state};
        this.state = newState;
        this.setState(newState)
    }
}
